<template>
  <div class="dash-empty">
    <i :class="['pi', icon]"></i>
    <div class="dash-empty-title">{{ title }}</div>
    <p v-if="message" class="dash-empty-message">{{ message }}</p>
    <div v-if="$slots.default" style="margin-top: 10px;">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardEmptyState',
  props: {
    icon: { type: String, default: 'pi-inbox' },
    title: { type: String, default: 'Nothing here yet' },
    message: { type: String, default: '' },
  },
};
</script>
